module.exports = __webpack_public_path__ + "files/692b2ac094cb0b2679dadd8cba568087.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Lato-regular.woff
 ** module id = 856
 ** module chunks = 0
 **/